import { createQuickViewBlock } from '@boost-sd/theme/core/blocks/quickview';

const quickViewBlock = createQuickViewBlock();

quickViewBlock.render();
